import { Typography } from 'antd';
import { omniChatMessages } from 'messages';
import OmniChatSessionAgentList from './OmniChatSessionAgentList';
import { UserCompactDto } from 'types';

type OmniChatSessionWaitingAssignUserProps = {
  onSelectUser?: (id: number, user: UserCompactDto) => void;
  selectedUserId?: number;
  onBack?: () => void;
};

const OmniChatSessionWaitingAssignUser: React.FC<OmniChatSessionWaitingAssignUserProps> = ({
  onSelectUser,
  selectedUserId,
  onBack
}) => {
  return (
    <div className='flex h-full flex-col'>
      <div className='flex h-14 items-center gap-2 px-4'>
        {/* <Button onClick={() => onBack?.()} shape='circle' icon={<LeftIcon />} className='h-8 w-8' type='text' /> */}
        <Typography.Text className='text-lg font-semibold capitalize'>{omniChatMessages.chooseDTV}</Typography.Text>
      </div>
      <div className='max-h-[calc(100%-56px)] overflow-hidden'>
        <OmniChatSessionAgentList onClickItem={onSelectUser} selectedUserId={selectedUserId} />
      </div>
    </div>
  );
};

export default OmniChatSessionWaitingAssignUser;
